module.exports = require("./../../_gen/starling/assets/ByteArrayFactory");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/assets/ByteArrayFactory.js
// module id = 153
// module chunks = 0